import { Buffer } from "buffer";

// for node-rsa
window.process = {};
window.Buffer = Buffer;
